const initialState = {
  authenticated: false,
  articles: [],
  backyardArticles: [],
  statistics: {},
  fullName: '',
  submitted: false,
  role: '',
  published: false,

};

export default initialState;
